<template>
  <div class="printme">
    <div class="visibility-hidden">
      <b-row>
        <b-col cols="4">
          <img
            src="../../assets/logo-promart.png"
            style="height: 80px; width: auto"
            alt=""
          />
        </b-col>
        <b-col cols="4">
          <p class="font-weight-500" style="margin-bottom: 0; margin-top: 8%">
            INFORME TÉCNICO
          </p>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-17" label="Cliente" label-for="input-17">
          <b-form-input
            :disabled="enableEdit"
            id="input-17"
            v-model="informTech.clientName"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="input-group-19" label="Tienda" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.codeStore"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-19" label="N° OS" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.numOs"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          id="input-group-19"
          label="Fecha de Servicio"
          label-for="input-19"
        >
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.dateService"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="6">
        <b-form-group
          id="input-group-50"
          label="Nombre de Técnico"
          label-for="input-19"
        >
          <b-form-input
            readonly
            id="input-50"
            v-model="informTech.technicianName"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="input-group-50" label="Estado" label-for="input-19">
          <b-form-input
            readonly
            id="input-50"
            v-model="informTech.state"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600" id="popover-hover" variant="primary">Descripción del área</label>
       <b-popover target="popover-hover" triggers="hover" placement="top">
          Descripción del área encontrada, especificar si el área se divide en ambientes
        </b-popover>
      
        <b-form-textarea
          :disabled="enableEdit"
          v-model="informTech.observationsArea"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          :state="validateLength"
          class="text-medium padding-two-bottom"
          @input="assertMaxChars"
          maxlength="500"
        >
        </b-form-textarea>
        <span class="limiter">{{ charactersLeft }}</span>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col md="12" class="padding-two-bottom">
         <label class="font-weigth-600" id="popover-hover-serv" variant="primary">Descripción del servicio</label>
        <b-popover target="popover-hover-serv" triggers="hover" placement="top">
         Detallar el servicio requerido, especificar que se va a realizar
        </b-popover>
        
        <b-form-textarea
          :disabled="enableEdit"
          v-model="informTech.detailServices"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          :state="validateLength"
          class="text-medium padding-two-bottom"
          @input="assertMaxChars"
          maxlength="500"
        >
        </b-form-textarea>
        
      </b-col>
    </b-row>
    <b-row class="visibility-hidden">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600">Descripción del área y servicios requeridos</label>
        <p class="text-medium padding-two-bottom">
          {{ informTech.observationsArea }}
        </p>
      </b-col>
    </b-row>
  <!--  <b-row class="no-printme">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600">Observaciones de los servicios requeridos</label>
        <b-form-textarea
          :disabled="enableEdit"
          v-model="informTech.detailServices"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="text-medium padding-two-bottom"
          maxlength="500"
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="visibility-hidden">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600">Observaciones de los servicios requeridos</label>
        <p class="text-medium padding-two-bottom">
          {{ informTech.detailServices }}
        </p>
      </b-col>
    </b-row> -->
    
    <b-row>
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600"> Detalle de los servicios requeridos</label>
      </b-col>
    </b-row>

    <b-row class="no-printme">
    
      <b-col cols="12" md="3" lg="3" >
        <label class="text-grey">SKU</label>
        <b-form-input
          @keyup="searchSkuServiceTimeout"
          placeholder="Escriba aquí"
          type="text"
          v-model="skuService"
        ></b-form-input>
      </b-col>
       <b-col cols="12" md="4" lg="4">
        <label class="text-grey">Descripción</label>
        <b-form-input
          :disabled="true"
          placeholder="Escriba aquí"
          type="text"
          v-model="skuServiceDes"
          class="description-read"
        ></b-form-input>
      </b-col> 
      <b-col cols="12" md="3" lg="3">
        <label class="text-grey">Cantidad</label>
        <b-form-input
          placeholder="Escriba aquí"
          type="number"
          v-model="quantitySku"
          class="description-read"
        ></b-form-input>
      </b-col>
      <b-col md="2">
        <b-button
          :disabled="isEnabled"
          @click="addSkuService"
          class="font-bolder btn-orange"
        >
          +</b-button
        >
      </b-col>
    </b-row>

    <b-row v-show="informTech.serviceMaterial.length">
      <b-col md="12">
        <b-table
          show-empty
          :items="servicesFiltered"
          :fields="fieldServices"
          striped
        >
          <template v-slot:cell(actions)="row">
            <b-button
              :disabled="enableEdit"
              size="sm"
              @click="deleteRow(row.item, row.index)"
              class="btn-rounded-red border-none no-printme"
              >Eliminar
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row v-show="showDetailsJob">
      <b-col cols="12" class="padding-two-bottom">
        <label class="font-weigth-600"  id="popover-hover-trabes" >Detalle de trabajos especiales</label>
        <b-popover target="popover-hover-trabes" triggers="hover" placement="top">
         Campo editable, aparece solo cuando se digita un SKU de trabajos especiales
        </b-popover>
       
      </b-col>
    </b-row>
    <b-row class="no-printme" v-show="showDetailsJob">
      <b-col cols="12" md="10" lg="10">
        <label class="text-grey">Detalle</label>
        <b-form-textarea
          :disabled="enableEdit"
          v-model="detailJob"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="text-medium padding-two-bottom"
        >
        </b-form-textarea>
      </b-col>

      <!--<b-col cols="12" md="3" lg="3">
        <label class="text-grey">Cantidad</label>
        <b-form-input
          placeholder="Escriba aquí"
          type="text"
          v-model="quantity"
          class="description-read"
        ></b-form-input>
      </b-col> -->
      <b-col md="2">
        <b-button
          :disabled="isEnabledSpecialJob"
          @click="addSpecialJob"
          class="font-bolder btn-orange"
        >
          +
        </b-button>
      </b-col>
    </b-row>
    <b-row v-show="informTech.specialJob.length">
      <b-col md="12">
        <b-table
          show-empty
          :items="specialJobFiltered"
          :fields="fieldJob"
          striped
        >
          <template v-slot:cell(actions)="row">
            <b-button
              size="sm"
              :disabled="enableEdit"
              @click="deleteSpecialJob(row.item, row.index)"
              class="btn-purple no-printme"
              >Eliminar
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weigth-600">Detalle de los materiales requeridos</label>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="12" md="4" lg="4">
        <label class="text-grey">Descripción</label>
        <b-form-input
          
          placeholder="Escriba aquí"
          type="text"
          v-model="descriptionMaterial"
          class="description-read"
        ></b-form-input>
      </b-col>
      <b-col cols="12" md="3" lg="3">
        <label class="text-grey">Cantidad</label>
        <b-form-input
          placeholder="Escriba aquí"
          type="number"
          v-model="quantityMaterial"
          class="description-read"
        ></b-form-input>
      </b-col>
      <b-col md="2">
        <b-button
          :disabled="isEnabledMaterial"
          @click="addMaterial"
          class="font-bolder btn-orange"
        >
          +</b-button
        >
      </b-col>
    </b-row>
    <b-row v-show="informTech.serviceMaterial.length">
      <b-col md="12">
        <b-table
          show-empty
          :items="servicesMaterialFiltered"
          :fields="fieldMaterial"
          striped
        >
          <template v-slot:cell(actions)="row">
            <b-button
              :disabled="enableEdit"
              size="sm"
              @click="deleteRow(row.item, row.index)"
              class="btn-rounded-red border-none no-printme"
              >Eliminar
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    
    
    <b-row class="no-printme">
      <b-col cols="12" class="padding-two-bottom">
        <label class="font-weigth-600" id="popover-hover-obsadx" variant="primary">Observaciones adicionales</label>
        <b-popover target="popover-hover-obsadx" triggers="hover" placement="top">
         Colocar información adicional sobre la realización del servicio o del área a trabajar
        </b-popover>

        <b-form-textarea
          :disabled="enableEdit"
          v-model="informTech.observationsAdditional"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="text-medium padding-two-bottom"
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="visibility-hidden">
      <b-col md="12" class="padding-two-bottom">
        <label class="font-weight-600">Observaciones adicionales</label>
        <p>{{ informTech.observationsAdditional }}</p>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="12" class="padding-two-bottom">
        <label class="font-weight-600">Tiempo aproximado de ejecución</label>
        <b-form-textarea
         
          v-model="informTech.timeExecution"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="text-medium padding-two-bottom"
        ></b-form-textarea>
      </b-col>
    </b-row>

    <b-row class="visibility-hidden">
      <b-col md="12">
        <p>Términos y condiciones</p>
        <ul>
          <li>
            Los servicios a realizar serán unicamente los que se encuentren dentro del presente documento.
          </li>
          <li>
           Los servicios a realizar serán unicamente los que se encuentren dentro del presente documento.
          </li>
          
        </ul>

       
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="12" style="text-align: -webkit-center">
        <b-carousel
          id="carousel-no-animation"
          v-model="slide"
          controls
          indicators
          no-animation
          background="#ababab"
          style="text-shadow: 1px 1px 2px #333; width: auto; height: 480px"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <!-- Text slides with image -->

          <div v-for="photo in photosRoute" :key="photo.id">
            <b-carousel-slide :img-src="photo.photoUrl"> </b-carousel-slide>
          </div>
          <!-- Slides with custom text -->
        </b-carousel>
      </b-col>
    </b-row>
    <b-row class="no-printme padding-three-top">
      <b-col cols="3" class="text-right" v-show="profileUser">
        <b-button @click="$bvModal.show('modal-mail')" class="btn-orange">
          <font-awesome-icon icon="inbox" /> ENVIAR
        </b-button>
      </b-col>
      <b-col cols="3" class="text-right" v-show="profileUser">
        <slot name="button-print"> </slot>
        
      </b-col>
      <b-col cols="3" class="text-center">
        <b-button
          :disabled="isEnabledSave"
          @click="editInform"
          class="bg-purple btn-grey"
        >
          <font-awesome-icon icon="trash" /> GUARDAR
        </b-button>
      </b-col>
      <b-col cols="3" class="text-left">
        <b-button
          :disabled="enableApprove"
          @click="processReport"
          class="btn-orange"
        >
          <font-awesome-icon icon="check-circle" /> APROBAR
        </b-button>
      </b-col>
    </b-row>
    <b-modal
      id="modal-mail"
      hide-footer
      title="Enviar correo"
      title-class="left-auto"
    >
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <p class="text-dark text-left">
            Una vez solicitado será enviado al correo electrónico específicado
          </p>
          <label class="text-dark font-weight-bold"
            >Correo electrónico de destino
          </label>
          <b-form-input
            @keyup="validateEmail"
            class="border-all"
            placeholder="Escribir"
            type="text"
            v-model="emailUser"
          ></b-form-input>
          <p>{{ msg }}</p>
        </b-row>

        <b-row>
          <b-col lg="6" class="padding-left-none">
            <b-button
              class="width-100 bg-white btn-white-v border-black-all color-gray"
              @click="$bvModal.hide('modal-mail')"
            >
              Cancelar
            </b-button>
          </b-col>
          <b-col lg="6" class="padding-rigth-none" v-if="profileUser">
            <b-button
              :disabled="isEnabledEmail"
              class="btn-dark width-100"
              @click="sendMail"
            >
              Enviar
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import { getPhotosRoute } from "../../assets/js/common";
export default {
  name: "InformeTecnico",
  data() {
    return {
      enableDescription: true,
      slide: 0,
      photosRoute: [],
      dismissSecs: 10,
      dismissCountDown: 0,
      msg: "",
      emailUser: "",
      currentPage: 1,
      perPage: 10,
      selectedOption: null,
      options: [
        { value: "A", text: "SERVICIO" },
        { value: "B", text: "MATERIAL" },
      ],
      fieldMaterial: [
        
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        
        { key: "actions", label: "" },
      ],
      fieldServices: [
        { key: "sku", label: "Sku" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        
        { key: "actions", label: "" },
      ],
      fieldJob: [
        { key: "description", label: "Descripción" },
        { key: "actions", label: "" },
      ],
      skuService: "",
      skuServiceDes: "",
      skuAgrupation:"",
      descriptionMaterial:"",
      quantityMaterial:"",
      quantitySku: "",
      quantity: "",
      detailJob: "",
      reportClient: "",
      inform: "",
      recomendation: "",
      maxLength: 500,
      variant: "",
      messageAlert: "",
      informTech: {
        idRoute: 0,
        codeStore: "",
        dniClient: "",
        dniTechnical: "",
        numOs: "",
        observationsArea: "",
        detailServices: "",
        observationsAdditional: "",
        dateService: "",
        id: "",
        serviceMaterial: [],
        specialJob: [],
        timeExecution:""
      },
    };
  },

  props: {
    idTechInform: {
      type: Number,
    },
  },
  created() {
    this.getInformTech();
  },
  computed: {
    ...mapState("module", ["username", "perfil","token"]),
    isEnabledEmail() {
      if (this.msg) return true;
      else return false;
    },
    showDetailsJob(){
      
      if(this.informTech.serviceMaterial.some((m) => m.specialJob === true)) return true
      else return false;
    },
    profileUser() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return false;
      else return true;
    },
    isEnabledSave(){
      let up = this.perfil.toUpperCase();
      if((up === "PROVEEDOR"||up === "ADMINISTRADOR") &&this.informTech.state == "PENDIENTE_APROBACION"){
        return false;
      }
      return true
    },
    enableEdit() {
      if (this.informTech.state == "APROBADO") return true;
      return false;
    },
    isEnabledSpecialJob() {
      if (this.detailJob.length > 0) return false;
      else return true;
    },
    isEnabled() {
      if (
       this.skuService.length > 0 &&
        this.quantitySku > 0 &&
        this.informTech.state != "APROBADO"
      )
        return false;
      else return true;
    },
    isEnabledMaterial(){
      if (
        this.descriptionMaterial.length > 0 &&
        this.quantityMaterial > 0 &&
        this.informTech.state != "APROBADO"
      )
        return false;
      else return true;
    },
    validateLength() {
      return this.informTech.observationsArea.length > 500 ? false : true;
    },
    charactersLeft() {
      var char = this.informTech.observationsArea.length;
      var limit = 500;
      if (limit - char < 0) {
        return "Has excedido la cantidad de caracteres permitidos";
      }
      return limit - char + " / " + limit + " caracteres restantes";
    },
    enableApprove() {
      let up = this.perfil.toUpperCase();
      if((up === "PROVEEDOR"||up === "ADMINISTRADOR") &&this.informTech.state == "PENDIENTE_APROBACION"){
        return false;
      }
      if (this.informTech.state == "APROBADO") {
        return true;
      }
      return true
    },
    servicesFiltered() {
      return this.informTech.serviceMaterial.filter((i) => i.deleted == false&&i.typeProduct=="SERVICIO");
    },
    servicesMaterialFiltered() {
      return this.informTech.serviceMaterial.filter((i) => i.deleted == false&&i.typeProduct=="MATERIAL");
    },
    specialJobFiltered() {
      return this.informTech.specialJob.filter((i) => i.deleted == false);
    },
  },
  methods: {
    enableInput() {
      if (this.selectedOption === "A") {
        this.enableDescription = true;
        this.skuServiceDes = "";
      } else if (this.selectedOption === "B") {
        this.enableDescription = false;
      }
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    assertMaxChars() {
      if (this.informTech.observationsArea.length >= this.maxLength) {
        this.informTech.observationsArea =
          this.informTech.observationsArea.substring(0, this.maxLength);
      }
    },
    validateEmail() {
      const mailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!mailRegex.test(this.emailUser)) {
        this.msg = "Ingrese un email válido";
      } else {
        this.msg = "";
      }
    },
    async sendMail() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.post(
          process.env.VUE_APP_BASE_API_VISIT_EXT + "/report/sendMail",
          {
            idReport: this.idTechInform,
            typeReport: "VTEC",
            email: this.emailUser,
          },
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        let values = {
          variant: "success",
          msg: response.data.message,
        };
        this.$store.commit("SET_ERROR_MSG", values);
        this.$store.commit("setShowAlert", true);
        console.log(response);
      } catch (e) {
        console.log(e);
      } finally {
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
        this.$store.commit("SET_LOADING", false);
      }
    },
    print() {
      window.print();
    },
    deleteRow(item) {
      console.log(item);
     
      //this.informTech.serviceMaterial.splice(i, 1);
      //this.formProvider.capacities[i].deleted = true;
      this.informTech.serviceMaterial.forEach((s) => {
      if (s.sku === item.sku) {
        s.deleted = true;
        s.created = false;
        s.specialJob = false;
      }
    });
    },
    deleteSpecialJob(item) {
      let i = this.informTech.specialJob.findIndex((s) => s.id == item.id);
      this.informTech.specialJob[i].deleted = true;
      this.informTech.specialJob[i].created = false;
      this.skuAgrupation="";
      //this.formProvider.capacities[i].deleted = true;
    },
   async addSkuService() {
      await this.getSkuService();
      let type =  "SERVICIO" ;
      if (this.selectedOption == "B") this.skuService = "NO APLICA";
      this.informTech.serviceMaterial.push({
        description: this.skuServiceDes,
        quantity: this.quantitySku,
        sku: this.skuService,
        typeProduct: type,
        idTvr: this.idTechInform,
        deleted: false,
        created: true,
        specialJob:this.skuAgrupation?true:false
      });
      this.skuService = "";
      this.quantitySku = "";
      this.skuServiceDes = "";
      this.skuAgrupation="";
    },
    addMaterial() {
      let type ="MATERIAL";
     // if (this.selectedOption == "B") this.skuService = "NO APLICA";
      this.informTech.serviceMaterial.push({
         description: this.descriptionMaterial,
        quantity: this.quantityMaterial,
        sku:"",
        typeProduct: type,
        idTvr: this.idTechInform,
        deleted: false,
        created: true,
      });
      //this.skuService = "";
      this.descriptionMaterial = "";
      this.quantityMaterial = "";
    },
    addSpecialJob() {
      this.informTech.specialJob.push({
        quantity: 0,
        description: this.detailJob,
        idTvr: this.idTechInform,
        created: true,
        deleted: false,
      });
      this.skuService = "";
      this.quantity = "";
      this.detailJob = "";
    },
    searchSkuService() {
      this.getSkuService();
      /*clearTimeout(this.timeout);
      let self = this;
      this.timeout = setTimeout(function () {
        self.getSkuService();
      }, 3000);*/
    },
    searchSkuServiceTimeout() {
      
      clearTimeout(this.timeout);
      let self = this;
      this.timeout = setTimeout(function () {
        self.getSkuService();
      }, 3000);
    },
    async getSkuService() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/services/" +
            this.skuService,
             {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);
        this.skuServiceDes = response.data.description;
        this.skuAgrupation=response.data.group;
      } catch (error) {
        console.error(error);
      }
    },
    async processReport(){
      try{
        this.$store.commit("SET_LOADING", true);
        await this.approveReport();
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      }
      catch(error){
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      }
      finally{
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
      
    },

    async createProject() {
      try {
        
        let response = await axios.post(
          process.env.VUE_APP_PROJECT_BASE ,
          {
            idReport:this.idTechInform,
            cotizaciones:[]
          },
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        
      } catch (error) {
        console.log(error)
      }
    },
    async approveReport() {
      try {
        this.informTech.state = "APROBADO";
        
        let response = await axios.put(
          process.env.VUE_APP_ORDERS_CORE_BASE + "/tvr/" + this.idTechInform,
          this.informTech,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        
      } catch (error) {
        console.log(error)
      } 
    },
    async editInform() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.put(
          process.env.VUE_APP_ORDER_BUSINESS_BASE +
            "/orders/tvr/update/" +
            this.idTechInform,
          this.informTech,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.$bvModal.hide('modal-informe')
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
        
      }
    },
    async getInformTech() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE + "/tvr/" + this.idTechInform
        );

        const specialJob = response.data.specialJob.map((c) => ({
          idTvr: this.idTechInform,
          description: c.description,
          quantity: c.quantity,
          deleted: false,
          id: c.id,
        }));
        const serviceMaterial = response.data.serviceMaterial.map((c) => ({
          idTvr: this.idTechInform,
          description: c.description,
          quantity: c.quantity,
          sku: c.sku,
          typeProduct: c.typeProduct,
          deleted: false,
          id: c.id,
        }));
        this.informTech = response.data;
        this.informTech.specialJob = specialJob;
        this.informTech.serviceMaterial = serviceMaterial;
        if (response.data.idRoute)
          this.photosRoute = await getPhotosRoute(response.data.idRoute);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.btn-orange {
  background: #ff7a00 !important;
  color: white;
  border-color: transparent !important;
  border-radius: 20px;
}
.btn-grey {
  border-radius: 20px !important;
}
.font-bolder {
  font-weight: bold;
  font-size: 23px;
  padding: 0;
  background: transparent;
  border-color: transparent;
}
@media print {
.modal {
        position: absolute;
        left: 0;
        top: 0;
        margin: 0;
        padding: 0;
        overflow: visible!important;
    }
  #modal-informe___BV_modal_header_ {
    visibility: hidden !important;
  }
  .limiter {
    display: none;
  }
  .no-printme {
    display: none;
  }
  .printme {
    display: block;
    size: 25cm 35.7cm;
    margin: 5mm 5mm 5mm 5mm;
  }
  .visibility-hidden {
    display: contents !important;
  }
  .text-modal-informe {
    visibility: hidden !important;
  }
}
@page {
  size: A4 landscape;
  margin: 50%;
}
.carousel-item {
  width: 500px;
  height: 480px;
  margin-right: auto !important;
  margin-left: auto !important;
  float: none !important;
}
.d-block {
  display: initial !important;
}
.carousel-item img {
  height: 480px;
  width: auto !important;
}
.visibility-hidden {
  display: none;
}
</style>
